// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"5ebe90bb","186":"b0179791","337":"01f2d56c","777":"811124ee"}[chunkId] + ".chunk.js";
};